module.exports = __webpack_public_path__ + "static/img/YesterdayTopIN.061ec54.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/DiwaliFestival/YesterdayTopIN.svg
// module id = t4KL
// module chunks = 0